import * as React from "react";
import classnames from "classnames";
/* empty css               */
const SplitPane = ({ main, aside, mainWidth = 50, flip }) => {
  const asideWidth = 100 - mainWidth;
  const mainPosition = flip ? "second" : "first";
  const asidePosition = flip ? "first" : "second";
  const mainClasses = classnames(
    "split-pane__main",
    `split-pane__main--ratio-${mainWidth}`,
    `split-pane--${mainPosition}`
  );
  const asideClasses = classnames(
    "split-pane__aside",
    `split-pane__aside--ratio-${asideWidth}`,
    `split-pane--${asidePosition}`
  );
  return /* @__PURE__ */ React.createElement("article", { className: "split-pane", "data-t": "split-pane" }, main && /* @__PURE__ */ React.createElement("div", { className: mainClasses, "data-t": "main-pane" }, main), aside && /* @__PURE__ */ React.createElement("aside", { className: asideClasses, "data-t": "side-pane" }, aside));
};
export {
  SplitPane as default
};
//# sourceMappingURL=SplitPane.js.map
